import { Component } from "@angular/core";


@Component({
    selector: "app-logged-out-dialog",
    templateUrl: "./logged-out-dialog.component.html",
    styleUrls: ["./logged-out-dialog.component.scss"]
})

export class LoggedOutDialogComponent
{
    constructor() { }

    ngOnInit(): void
    {
    }

}